import { SiMicrosoft as CopilotStudioIcon } from 'react-icons/si';

import { PLACEHOLDER } from './placeholders';
import {
  AUTH_TOKEN,
  BLOCK_FILE,
  BLOCK_INSTRUCTIONS,
  BLOCK_WARNING,
  CLIENT_STATUS_SUPPORTED
} from './constants';

const swaggerSnippet = `paths:
  /mcp:
    post:
      x-ms-agentic-protocol: mcp-streamable-1.0
      operationId: InvokeMCP
      parameters:
        - name: X-Faraday-URL
          in: header
          type: string
          required: true
          default: ${PLACEHOLDER.instanceUrl}
      responses:
        "200":
          description: Success`;

const copilotStudio = {
  id: 'copilotStudio',
  label: 'Copilot Studio',
  subLabel: 'Microsoft',
  icon: CopilotStudioIcon,
  status: CLIENT_STATUS_SUPPORTED,
  authMethods: [AUTH_TOKEN],
  summaryId: 'mcp.client.copilotStudio.summary',
  buildSections: () => [
    {
      id: 'wizard',
      titleId: 'mcp.client.copilotStudio.wizard.title',
      blocks: [
        {
          id: 'wizard-steps',
          type: BLOCK_INSTRUCTIONS,
          items: [
            { id: 'open', textId: 'mcp.client.copilotStudio.wizard.open' },
            { id: 'name', textId: 'mcp.client.copilotStudio.wizard.name' },
            { id: 'url', textId: 'mcp.client.copilotStudio.wizard.url' },
            { id: 'auth', textId: 'mcp.client.copilotStudio.wizard.auth' },
            { id: 'create', textId: 'mcp.client.copilotStudio.wizard.create' }
          ]
        }
      ]
    },
    {
      id: 'instance-address',
      titleId: 'mcp.client.copilotStudio.connector.title',
      blocks: [
        {
          id: 'connector-steps',
          type: BLOCK_INSTRUCTIONS,
          items: [
            { id: 'edit', textId: 'mcp.client.copilotStudio.connector.edit' },
            { id: 'swagger', textId: 'mcp.client.copilotStudio.connector.swagger' },
            { id: 'parameter', textId: 'mcp.client.copilotStudio.connector.parameter' },
            { id: 'readd', textId: 'mcp.client.copilotStudio.connector.readd' }
          ]
        },
        {
          id: 'swagger-file',
          type: BLOCK_FILE,
          captionId: 'mcp.client.copilotStudio.connector.caption',
          snippet: swaggerSnippet
        },
        {
          id: 'known-issue',
          type: BLOCK_WARNING,
          titleId: 'mcp.client.copilotStudio.knownIssue.title',
          textId: 'mcp.client.copilotStudio.knownIssue.text'
        }
      ]
    }
  ]
};

export default copilotStudio;
